module.exports = __webpack_public_path__ + "static/media/banner_bg.b03c25ca.svg";